export const PRICING_TYPE_STANDARD = "standard";
export const PRICING_TYPE_SUBSIDIZED = "subsidized";
export const PRICING_TYPE_CATERER = "caterer";
export const PRICING_TYPE_COUPONS = "coupons";

// Soumissions qui ne passent pas par la validation client : la facture est
// générée et envoyée directement (aide alimentaire, coupons). Miroir de
// PricingTypes::PRICING_TYPES_WITHOUT_CLIENT_VALIDATION côté API.
export const PRICING_TYPES_WITHOUT_CLIENT_VALIDATION = [
  PRICING_TYPE_SUBSIDIZED,
  PRICING_TYPE_COUPONS,
];

// Soumissions dont la date d'évènement n'est qu'une date de référence de
// période : l'heure n'a pas de sens métier et ne doit pas être affichée.
export const PRICING_TYPES_WITHOUT_EVENT_TIME = [
  PRICING_TYPE_SUBSIDIZED,
  PRICING_TYPE_COUPONS,
];

export function pricingTypeRequiresClientValidation(pricingType) {
  return !PRICING_TYPES_WITHOUT_CLIENT_VALIDATION.includes(pricingType);
}

export function pricingTypeHasEventTime(pricingType) {
  return !PRICING_TYPES_WITHOUT_EVENT_TIME.includes(pricingType);
}

/**
 * Pour une soumission chargée depuis l'API, on se fie à l'attribut qu'elle
 * expose (source de vérité côté serveur) et on retombe sur la liste locale
 * sinon (objet en cours de création, API pas encore déployée).
 */
export function salesOrderRequiresClientValidation(salesOrder) {
  if (typeof salesOrder?.requires_client_validation === "boolean") {
    return salesOrder.requires_client_validation;
  }
  return pricingTypeRequiresClientValidation(salesOrder?.pricing_type);
}

export function salesOrderHasEventTime(salesOrder) {
  if (typeof salesOrder?.has_event_time === "boolean") {
    return salesOrder.has_event_time;
  }
  return pricingTypeHasEventTime(salesOrder?.pricing_type);
}
